import React, { useState } from "react";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";

// ✅ University Logos
const logos = {
  UniversityofUtah: "/img/university/University-of-Utah-Logo.webp",
  UtahStateUniversity: "/img/university/Utah State University.webp",
  southernUtahUniversity: "/img/university/Southern Utah University.webp",
  USUBrigham: "/img/university/USU Brigham.webp",
  USUEastern: "/img/university/USU Eastern.webp",
  USUToole: "/img/university/USU Tooele.webp",
  USUunnitah: "/img/university/USU Uintah Basin.webp",
  UtahTech: "/img/university/Utah Tech University.webp",
  UtahValley: "/img/university/Utah Valley University.webp",
  weber: "/img/university/Weber State University.webp",
  saltLake: "/img/university/Salt Lake College.webp",
  snowCollege: "/img/university/Snow College.webp",
  bridgerland: "/img/university/Bridgerland Tech College.webp",
  davis: "/img/university/Davis Tech College.webp",
  Dixie: "/img/university/Dixie Tech College.webp",
  Mountainland: "/img/university/Mountainland Tech College.webp",
  brigham: "/img/university/Brigham Young University.webp",
  broadview: "/img/university/Broadview University.webp",
  eaglegatecollege: "/img/university/Eagle gate College.webp",
  ensign: "/img/university/Ensign College.webp",
  fortis: "/img/university/Fortis College.webp",
  neumont: "/img/university/Neumont College.webp",
  nightingale: "/img/university/Nightingale.webp",
  OgdenWeber: "/img/university/Ogden Weber Tech College.webp",
  provocollege: "/img/university/Provo College.webp",
  Rocky: "/img/university/Rocky Mountain University.webp",
  roseman: "/img/university/Roseman University.webp",
  Southwest: "/img/university/SouthWest Tech College.webp",
  Stevens: "/img/university/Stevens Henager College.webp",
  tooele: "/img/university/Tooele Tech College.webp",
  Uintah: "/img/university/Uintah Basin Tech College.webp",
  phoenix: "/img/university/University of Phoenix.webp",
  webster: "/img/university/Webster University.webp",
  Western: "/img/university/Western Governors University.webp",
  westminstercollege: "/img/university/Westminster University.webp",
  rockyVista: "/img/university/Rocky Vista University.webp",
};

// ✅ University Data
const institutions = [
  { category: "Public Research Universities", name: "University of Utah", logo: logos.UniversityofUtah, website: "https://www.utah.edu" , address:"201 Presidents' Cir, Salt Lake City, UT 84112, United States"},
  { category: "Public Research Universities", name: "Utah State University", logo: logos.UtahStateUniversity, website: "https://www.usu.edu" , address:"Old Main Hill, Logan, UT 84322, United States"},
 
  { category: "Public Regional Universities", name: "Southern Utah University", logo: logos.southernUtahUniversity, website: "https://www.suu.edu" , address:"351 W University Blvd, Cedar City, UT 84720, United States"},
  { category: "Public Regional Universities", name: "USU-Brigham City", logo: logos.USUBrigham, website: "https://www.statewide.usu.edu/brighamcity", address:"989 S Main St, Brigham City, UT 84302, United States"},
  { category: "Public Regional Universities", name: "USU-Eastern", logo: logos.USUEastern, website: "https://www.eastern.usu.edu" , address:"451 E 400 N, Price, UT 84501, United States"},
  { category: "Public Regional Universities", name: "USU-Tooele", logo: logos.USUToole, website: "https://www.statewide.usu.edu/tooele" , address:"1021 W Vine St, Tooele, UT 84074, United States"},
  { category: "Public Regional Universities", name: "USU-Uintah Basin", logo: logos.USUunnitah, website: "https://www.statewide.usu.edu/uintahbasin" , address:"320 Aggie Blvd, Vernal, UT 84078, United States"},
  { category: "Public Regional Universities", name: "Utah Tech University", logo: logos.UtahTech, website: "https://www.utahtech.edu", address:"225 S Univ Ave, St. George, UT 84770, United States"},
  { category: "Public Regional Universities", name: "Utah Valley University", logo: logos.UtahValley, website: "https://www.uvu.edu" , address:"800 W University Pkwy, Orem, UT 84058, United States"},
  { category: "Public Regional Universities", name: "Weber State University", logo: logos.weber, website: "https://www.weber.edu", address:"3848 Harrison Blvd, Ogden, UT 84403, United States"},
 
  { category: "Comprehensive Community Colleges", name: "Salt Lake Community College", logo: logos.saltLake, website: "https://www.slcc.edu" , address:"4600 S Redwood Rd, Taylorsville, UT 84123, United States"},
  { category: "Comprehensive Community Colleges", name: "Snow College", logo: logos.snowCollege, website: "https://www.snow.edu" , address:"150 College Ave E, Ephraim, UT 84627, United States"},
 
  { category: "Technical Colleges", name: "Bridgerland Technical College", logo: logos.bridgerland, website: "https://www.btech.edu", address:"1301 North 600 West, Logan, Utah 84321, United States"},
  { category: "Technical Colleges", name: "Davis Technical College", logo: logos.davis, website: "https://www.davistech.edu" , address:"550 E 300 S, Kaysville, UT 84037, United States"},
  { category: "Technical Colleges", name: "Dixie Technical College", logo: logos.Dixie, website: "https://www.dixietech.edu" , address:"610 S Tech Ridge Dr, St. George, UT 84770, United States"},
  { category: "Technical Colleges", name: "Mountainland Technical College", logo: logos.Mountainland, website: "https://www.mtec.edu", address:"2301 West Ashton Blvd., Lehi, Utah 84043, United States"},
  { category: "Technical Colleges", name: "Ogden–Weber Technical College", logo: logos.OgdenWeber, website: "https://www.otech.edu" , address:"200 N Washington Blvd, Ogden, UT 84404, United States"},
  { category: "Technical Colleges", name: "Southwest Technical College", logo: logos.Southwest, website: "https://www.stech.edu", address:"757 West 800 South, Cedar City, Utah 84720, United States"},
  { category: "Technical Colleges", name: "Tooele Technical College", logo: logos.tooele, website: "https://www.tooeletech.edu" , address:"88 S Tooele Blvd, Tooele, UT 84074, United States"},
  { category: "Technical Colleges", name: "Uintah Basin Technical College", logo: logos.Uintah, website: "https://www.ubtech.edu" , address:"1100 E Lagoon St, Roosevelt, UT 84066, United States"},
 
  { category: "Private Non-Profit Institutions", name: "Brigham Young University", logo: logos.brigham, website: "https://www.byu.edu" , address:"Provo, UT 84602, United States"},
  { category: "Private Non-Profit Institutions", name: "Ensign College", logo: logos.ensign, website: "https://www.ensign.edu" , address:"95 N 300 W, Salt Lake City, UT 84101, United States"},
  { category: "Private Non-Profit Institutions", name: "Western Governors University", logo: logos.Western, website: "https://www.wgu.edu" , address:"4001 S 700 E #300, Millcreek, UT 84107, United States"},
  { category: "Private Non-Profit Institutions", name: "Westminster University", logo: logos.westminstercollege, website: "https://www.westminstercollege.edu", address:"1840 South 1300 East, Salt Lake City, Utah 84105, United States"},
 
  { category: "Private For-Profit Institutions", name: "Broadview University", logo: logos.broadview, website: "https://www.broadviewuniversity.edu" , address:"1902 W 7800 S, West Jordan, UT 84088, United States"},
  { category: "Private For-Profit Institutions", name: "Eagle Gate College", logo: logos.eaglegatecollege, website: "https://www.eaglegatecollege.edu", address:"915 N 400 W, Layton, Utah 84041, United States"},
  { category: "Private For-Profit Institutions", name: "Fortis College", logo: logos.fortis, website: "https://www.fortis.edu" , address:"3949 S 700 E Ste 150, Salt Lake City, Utah 84107, United States"},
  { category: "Private For-Profit Institutions", name: "Neumont College of Computer Science", logo: logos.neumont, website: "https://www.neumont.edu" , address:"143 S Main St, Salt Lake City, UT 84111, United States"},
  { category: "Private For-Profit Institutions", name: "Nightingale College", logo: logos.nightingale, website: "https://www.nightingale.edu" , address:"95 S State St Suite 400, Salt Lake City, Utah 84111, United States"},
  { category: "Private For-Profit Institutions", name: "Provo College", logo: logos.provocollege, website: "https://www.provocollege.edu" , address:"1450 W 820 N, Provo, UT 84601, United States"},
  { category: "Private For-Profit Institutions", name: "Rocky Mountain University of Health Professions", logo: logos.Rocky, website: "https://www.rm.edu" , address:"1800 S Novell Pl, Provo, UT 84606, United States"},
  { category: "Private For-Profit Institutions", name: "Rocky Vista University", logo: logos.rockyVista, website: "https://www.rvu.edu" , address:"255 East Center Street, Ivins, Utah 84738-6756, United States"},
  { category: "Private For-Profit Institutions", name: "Roseman University of Health Sciences", logo: logos.roseman, website: "https://www.roseman.edu", address:"10920 S.River Front Parkway, South Jordan, UT 84095, United States"},
  { category: "Private For-Profit Institutions", name: "Stevens-Henager College", logo: logos.Stevens, website: "https://www.stevenshenager.edu" , address:"383 W Vine St Ste 100, Salt Lake City, UT 84123, United States"},
  { category: "Private For-Profit Institutions", name: "University of Phoenix", logo: logos.phoenix, website: "https://www.phoenix.edu" , address:"5373 S Green St, Murray, UT 84123, United States"},
  { category: "Private For-Profit Institutions", name: "Webster University", logo: logos.webster, website: "https://www.webster.edu" , address:"3848 Harrison Blvd, Ogden, UT 84403, United States"},
];

const UtahUniversities = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // Filter institutions
  const filteredInstitutions = institutions.filter(
    (inst) =>
      inst.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      inst.category.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentInstitutions = filteredInstitutions.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredInstitutions.length / rowsPerPage);

  return (
    <div>
      <LandingSection
        data={{
          imageName: "universitylanding.webp",
          title: "Utah Universities",
        }}
      />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>
              Centers of Knowledge and Innovation, Utah’s Leading Hubs for Higher Education
            </h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah's higher education system features a mix of public and private institutions,
              governed by the Utah System of Higher Education (USHE), which oversees 16 public colleges
              and universities—including prominent research schools like the University of Utah and
              Utah State University—as well as several technical colleges.
            </p>
          </div>
        </div>
      </div>

      <div className="min-h-screen flex flex-col items-center justify-center">
        <div className="overflow-x-auto w-full px-4 sm:px-8 lg:px-16 mb-[3rem]">
          <div className="text-center text-3xl sm:text-4xl lg:text-5xl font-bold mt-[5rem] mb-5">
            <h1 className="text-blue-900">Utah Higher Education Institutions</h1>
            <div className="mt-2 font-bold text-2xl text-[#CB0C0C]">
              ({institutions.length} Universities)
            </div>
          </div>

          {/* 🔍 Search Bar */}
          <div className="flex justify-center mb-6">
            <input
              type="text"
              placeholder="Search institutions or categories..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1); // reset page on search
              }}
              className="w-[90%] sm:w-[60%] px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div className="flex items-center justify-center my-12">
            <div className="bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
              <div className="overflow-x-auto max-h-[1000px]">
                <table className="min-w-full border border-gray-300">
                  <thead className="rounded-lg border border-pink-700 bg-red-200/50 hover:border-[1px] transition-all duration-200 sticky top-0 z-10">
                    <tr>
                      <th className="px-6 py-4 text-center text-[18px] font-bold text-blue-800 tracking-wider border border-gray-300">
                        Category
                      </th>
                      <th className="px-6 py-4 text-center text-[18px] font-bold text-blue-800 tracking-wider border border-gray-300">
                        Institution
                      </th>
                      <th className="px-6 py-4 text-center text-[18px] font-bold text-blue-800 tracking-wider border border-gray-300">
                        Address
                      </th>
                      <th className="px-6 py-4 text-center text-[18px] font-bold text-blue-800 tracking-wider border border-gray-300">
                        Website
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentInstitutions.map((inst, index) => (
                      <tr key={index} className="hover:bg-gray-100">
                        <td className="border border-gray-300 px-4 py-2 text-center font-medium">
                          {inst.category}
                        </td>
                        <td className="border border-gray-300 px-4 py-2 flex items-center">
                          <img src={inst.logo} alt={inst.name} className="w-[6rem] h-auto mx-[2rem]" />
                          {inst.name}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">{inst.address}</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <a
                            href={inst.website}
                            className="text-blue-600 underline"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {inst.website.replace("https://", "")}
                          </a>
                        </td>
                      </tr>
                    ))}

                    {currentInstitutions.length === 0 && (
                      <tr>
                        <td colSpan="4" className="text-center py-6 text-gray-500">
                          No results found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ✅ Pagination Controls */}
              <div className="flex justify-center items-center gap-4 py-4 bg-blue-50">
                <button
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-300"
                >
                  Previous
                </button>
                <span className="font-medium text-blue-900">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 bg-blue-600 text-white rounded disabled:bg-gray-300"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UtahUniversities;